import { Link } from 'react-router-dom';
import { SEVERITY_LABELS, type TodoItem } from './types';
import './todo.css';

/** The entries, each a link to where it is done; a coloured dot says how urgent (pilne red, uwaga orange, info grey). */
export function TodoEntries({ items, label }: { items: TodoItem[]; label: string }) {
  return (
    <ul className="todo-list" aria-label={label}>
      {items.map((i) => (
        <li key={i.id} className={`todo-row ${i.severity}`}>
          <span className="todo-mark" role="img" aria-label={SEVERITY_LABELS[i.severity]} />
          <span className="todo-main">
            <Link to={i.link} className="todo-title">
              {i.title}
            </Link>
            {i.detail !== '' && <span className="todo-detail">{i.detail}</span>}
          </span>
        </li>
      ))}
    </ul>
  );
}
